'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002417 from "./presto.-Agent-View$$anon$17.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Shodo-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$16() {
  this.awx = null;
  this.awp = null;
  this.awq = false;
  this.awy = null;
  this.awz = false;
  this.awC = null;
  this.awv = null;
  this.aww = false;
  this.awr = null;
  this.aws = false;
  this.awt = null;
  this.awu = false;
  this.awA = false;
  this.awB = false;
  this.awx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awC = "LocalShodoCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$16 as $c_Lpresto_AgentView$$anon$16 };
$p = $c_Lpresto_AgentView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$16;
/** @constructor */
function $h_Lpresto_AgentView$$anon$16() {
}
export { $h_Lpresto_AgentView$$anon$16 as $h_Lpresto_AgentView$$anon$16 };
$h_Lpresto_AgentView$$anon$16.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.awx;
});
$p.L = (function() {
  if ((!this.awq)) {
    this.awp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awq = true;
  }
  return this.awp;
});
$p.O = (function() {
  if ((!this.awz)) {
    this.awy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awz = true;
  }
  return this.awy;
});
$p.E = (function() {
  return this.awC;
});
$p.t = (function() {
  if ((!this.aww)) {
    this.awv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aww = true;
  }
  return this.awv;
});
$p.M = (function() {
  if ((!this.aws)) {
    this.awr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aws = true;
  }
  return this.awr;
});
$p.Q = (function() {
  if ((!this.awu)) {
    this.awt = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002417.$c_Lpresto_AgentView$$anon$17();
    this.awu = true;
  }
  return this.awt;
});
$p.w = (function() {
  if ((!this.awB)) {
    this.awA = false;
    this.awB = true;
  }
  return this.awA;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee110) => ((p) => \u03b4scrutinee110.cFQ(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalShodoCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$16, "presto.AgentView$$anon$16", ({
  DE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$16 as $d_Lpresto_AgentView$$anon$16 };
//# sourceMappingURL=presto.-Agent-View$$anon$16.js.map
